import { jsx as _jsx } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { MediumFormatting, LinkFormatting } from "@faire/web--source/common/localization/formatting";
import { Typography } from "@faire/web--source/slate/Typography";
import { AlertBanner } from "@faire/web--source/ui/AlertBanner";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackBrandPreviewFairesArrangementLinkClick } from "@faire/web-api--source/events/brandPreview/click/fairesArrangementLink";
import { trackBrandPreviewReturnToBrandPortalLinkClick } from "@faire/web-api--source/events/brandPreview/click/returnToBrandPortalLink";
import { trackRetailerOnboardingTopPromoBannerView } from "@faire/web-api--source/events/retailerOnboarding/view/topPromoBanner";
import brandPortal from "@faire/web-api--source/routes/brand-portal";
import * as React from "react";
import { useEffect } from "react";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
export var SEE_IT_IN_ACTION_LINK = "https://www.loom.com/share/310d410c13514dbeab63c3c26fb69e41?sid=b1050cf2-1b83-4320-9e55-73bf63704f0a";
export var BrandPreviewBanner = function() {
    var brandPreviewContent = useBrandPreviewContent();
    useEffect(function() {
        // Special case banner that is not part of the normal banner rotation
        trackRetailerOnboardingTopPromoBannerView(PromoBannerType.BRAND_PREVIEW);
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        "data-test-id": "brand-preview-banner",
        children: /*#__PURE__*/ _jsx(AlertBanner, {
            color: Decorative.tint.neutral,
            message: /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.primary,
                align: "center",
                children: brandPreviewContent
            })
        })
    });
};
var useBrandPreviewContent = function() {
    var _getBrand, _getBrand1, _getBrand2;
    var isActiveBrand = !!((_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.first_active_at);
    var isInactiveBrand = !((_getBrand1 = getBrand()) === null || _getBrand1 === void 0 ? void 0 : _getBrand1.first_active_at);
    var _getBrand_active_products_count;
    var isInactiveBrandWithProducts = isInactiveBrand && ((_getBrand_active_products_count = (_getBrand2 = getBrand()) === null || _getBrand2 === void 0 ? void 0 : _getBrand2.active_products_count) !== null && _getBrand_active_products_count !== void 0 ? _getBrand_active_products_count : 0) > 0;
    switch(true){
        case isActiveBrand:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "zEso+m",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Retailers will see a unique product arrangement based on their store type and browsing behavior. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "See it in action"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting(SEE_IT_IN_ACTION_LINK, {
                        target: "_blank",
                        onClick: function() {
                            return trackBrandPreviewFairesArrangementLinkClick();
                        }
                    })
                }
            });
        case isInactiveBrandWithProducts:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "afzOfn",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Previewing your shop."
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Retailers will see a unique product arrangement based on their store type and browsing behavior. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "See it in action"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting(SEE_IT_IN_ACTION_LINK, {
                        target: "_blank",
                        onClick: function() {
                            return trackBrandPreviewFairesArrangementLinkClick();
                        }
                    })
                }
            });
        case isInactiveBrand:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "YT6caw",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Previewing your shop."
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " When you\u2019re ready, you can activate this page from your portal. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Go to portal"
                            }
                        ]
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    LinkFormatting: LinkFormatting(brandPortal(), {
                        target: "_blank",
                        onClick: function() {
                            return trackBrandPreviewReturnToBrandPortalLinkClick();
                        }
                    })
                }
            });
        default:
            return null;
    }
};
